import { render, staticRenderFns } from "./CommentOne.vue?vue&type=template&id=1aefc008&"
import script from "./CommentOne.vue?vue&type=script&lang=js&"
export * from "./CommentOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports